import React from "react";

import type { CircleIconProps } from "./types";

const SquareIcon = ({ fill }: CircleIconProps) => (
  <rect
    rx={4}
    width={12}
    height={12}
    fill={fill}
  />
);

export default SquareIcon;
